import { useContext } from 'react'
import LinearScale from 'linear-scale'
import { clamp } from '@utils/math.js'
import Context from '../context.js'
import { scrollerSelector } from '../selectors/scroller_selectors.js'
import { getScrubberDisplayData } from '../selectors/static_scrubber_display_selectors.js'
import { scrubberBoundsSelector, cursorSelector } from '../selectors/scrubber_display_selectors.js'
import { updateLeftAndRight, cancelFreeScroll } from '../actions.js'
import Scrubber from '../components/scrubber/scrubber.jsx'

const ScrubberDisplayContainer = props => {
  const { state, dispatch } = useContext(Context)

  const scrollerData = scrollerSelector(state, props)
  const { x, y, width, height } = scrubberBoundsSelector(state, props)
  const scrubberData = getScrubberDisplayData(state, props)
  const { maxWidthRatio, minWidthRatio } = scrollerData
  const { gripperWidth, gripperHeight, handleWidth, handleHeight } = scrubberData

  const surfaceWidth = width
  const surfaceHeight = height

  // TODO: We can probably move some of these calculations to the scrubber display selector
  const scale = LinearScale([0, scrollerData.surface.width], [0, width])

  // use scroller data to calculate viewport position/size
  const viewportX = scale(Math.abs(scrollerData.surface.x))
  const viewportY = 0
  const viewportWidth = scale(scrollerData.viewport.width)
  const viewportHeight = height

  const cursors = cursorSelector(state, props)

  const newProps = {
    ...props,
    // scrubber bounds
    x,
    y,
    width,
    height,
    // cursors
    cursors,
    // surface
    surfaceWidth,
    surfaceHeight,
    // viewport
    viewportX,
    viewportY,
    viewportWidth,
    viewportHeight,
    // scroller data
    maxWidthRatio,
    minWidthRatio,
    // scrubber
    gripperWidth,
    gripperHeight,
    handleWidth,
    handleHeight,

    // callbacks
    onViewportPanStart: () => {
      dispatch(cancelFreeScroll())
    },
    onViewportPanMove: (left, right) => {
      dispatch(updateLeftAndRight(clamp(left, 0, 1), clamp(right, 0, 1)))
    },
    onViewportPanEnd: () => {},
  }

  return <Scrubber {...newProps} />
}

export default ScrubberDisplayContainer
